(function() {
  'use strict';

  angular
    .module('bsoc', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'angularUtils.directives.dirPagination',
      'ngPassword'
    ]);
})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .filter('societyFilter', societyFilter);

    function societyFilter($log){
      return function (input, country) {
        $log.log(input, country);
        if (country == 'All') {
          return input;

        } else {
          input = input || [];
          var out = [];
          input.forEach(function (item) {
            // console.log("current item is", item);
            if (item.countryName == country) {
              out.push(item);
            }
          });
          return out;
        }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .directive('pageTitle', pageTitle);

  /**
   * pageTitle - Directive to set Page title
   */
  function pageTitle($rootScope, $timeout) {
    return {
      link: function(scope, element) {
        var listener = function(event, toState) {
          // default title
          var title = 'Bible Society Locations';
          if (toState.data && toState.data.pageTitle) title = toState.data.pageTitle;
          $timeout(function() {
            element.text(title);
          });
        };
        $rootScope.$on('$stateChangeStart', listener);
      }
    }
  }

})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .controller('PageController', PageController)

  function PageController($log) {
    var vm = this;

    vm.pageChangeHandler = function(num) {
      $log.log('going to page ' + num);
    };
  }

})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .controller('MainCountryController', MainCountryController)

  function MainCountryController() {
    var vm = this;

    vm.loading = true;

    vm.currentPage = 1;
    vm.pageSize = 20;
    vm.films = [];

    vm.alphabet = "All,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,#".split(",");

    vm.setActive = function(letter){
      vm.loading = true;

      this.active = letter.toLowerCase();

      // FilmFactory.getFilms(letter).then(function(response){
      //   vm.films = response.data;
      //   vm.loading = false;
      // });
    }
  }

})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .controller('MainController', MainController)

  function MainController($log, Countries, Societies) {
    var vm = this;

    vm.countries = Countries.data;
    vm.societies = Societies.data;

    vm.selectedCountry = 'All';
  }

})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .filter('firstLetter', firstLetter);

    function firstLetter(){
      return function (input, letter) {
        if (letter == 'All') {
          return input;

        } else {
          input = input || [];
          var out = [];
          input.forEach(function (item) {
            // console.log("current item is", item);
            if (item.name.charAt(0) == letter) {
              out.push(item);
            }
          });
          return out;
        }
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .factory('SocietyFactory', SocietyFactory);

  function SocietyFactory($http){
    var service = {
      getData: getData,
      editSociety: editSociety,
      deleteSociety: deleteSociety,
      addSociety: addSociety
    }

    return service;

    function getData(){
      return $http({
        url: 'app/admin/api/societies/getSocieties.php',
        method: 'GET'
      });
    }

    function deleteSociety(id){
      var data = {
        id: id
      };

      return $http({
        url: 'app/admin/api/societies/deleteSociety.php',
        method: 'DELETE',
        data: data
      });
    }

    function editSociety(postData){
      return $http({
        url: 'app/admin/api/societies/editSociety.php',
        method: 'PUT',
        data: postData
      });
    }

    function addSociety(postData){
      return $http({
        url: 'app/admin/api/societies/addSociety.php',
        method: 'POST',
        data: postData
      });
    }
  }
})();

(function(){
  'use strict';

  angular
    .module('bsoc')
    .factory('CountryFactory', CountryFactory);

  function CountryFactory($http){
    var service = {
      getData: getData,
      editCountry: editCountry,
      deleteCountry: deleteCountry,
      addCountry: addCountry
    }

    return service;

    function getData(){
      return $http({
        url: 'app/admin/api/countries/getCountries.php',
        method: 'GET'
      });
    }

    function deleteCountry(id){
      var data = {
        id: id
      };

      return $http({
        url: 'app/admin/api/countries/deleteCountry.php',
        method: 'DELETE',
        data: data
      });
    }

    function editCountry(postData){
      return $http({
        url: 'app/admin/api/countries/editCountry.php',
        method: 'POST',
        data: postData
      });
    }

    function addCountry(name){
      var data = {
        name: name
      }

      return $http({
        url: 'app/admin/api/countries/addCountry.php',
        method: 'POST',
        data: data
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('bsoc')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {
  }

})();

(function() {
  'use strict';

  angular
    .module('bsoc')
    .config(routerConfig);

  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider, $urlMatcherFactoryProvider) {
    $locationProvider.html5Mode(true);
    $urlMatcherFactoryProvider.strictMode(false)

    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/home.html',
        controller: 'MainController as main',
        resolve: {
          Countries: function(CountryFactory){
            return CountryFactory.getData()
          },
          Societies: function(SocietyFactory){
            return SocietyFactory.getData()
          }
        }
      })
      .state('otherwise', {
        url: '/*path',
        data: { pageTitle: 'Page Not Found' },
        templateUrl: 'app/404.html'
      });
  }

})();

angular.module("bsoc").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/404.html","<div class=\"middle-box text-center animated fadeInDown\"><h1>404</h1><h3 class=\"font-bold\">Page Not Found</h3><div class=\"error-desc\">Sorry, but the page you are looking for has not been found.</div></div>");
$templateCache.put("app/main/dirPagination.tpl.html","<ul class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" ng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.last)\">&raquo;</a></li></ul>");
$templateCache.put("app/main/footer.html","<footer></footer>");
$templateCache.put("app/main/home.html","<div class=\"container\"><div class=\"text-center\"><img src=\"/assets/images/bible-society-locations-header.jpg\" alt=\"World Bible Society Locations\" width=\"100%\"></div><hr><p>Many people in the USA are trying to buy Bibles and New Testaments for people in locations around the world. Many people think they have to buy the buy the Bibles or New Testaments in the USA and ship them to other countries. It will be very expensive to ship them to a country.</p><p>It is better to look up the Bible Society or reseller in that country and buy it from the Bible Society in that country. The Bible Society is usually located in the capital city of the country.</p><p>Usually the Bible Societies around the world have good prices and sometimes a larger selection that what could be found in the USA in a certain language. If you want to buy a Bible for New Testament for someone who does not live in the capital city, perhaps the Bible Society will know of a reseller in other cities.</p><hr><div class=\"animated fadeIn\" ng-show=\"!loading\"><div class=\"row\"><div class=\"col-sm-4\"><select ng-model=\"main.selectedCountry\" class=\"form-control\"><option value=\"All\">Filter by Country</option><option ng-repeat=\"country in main.countries\" value=\"{{country.name}}\">{{country.name}}</option></select><br class=\"visible-xs\"></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-model=\"main.textFilter\" placeholder=\"Search by Keyword\"></div></div><hr><div class=\"row\" ng-show=\"main.filteredSocietiesArray.length == 0\"><div class=\"col-sm-4 hidden-sm hidden-xs\"></div><div class=\"col-sm-4 text-center\"><div class=\"society-card\">No results.</div></div><div class=\"col-sm-4 hidden-sm hidden-xs\"></div></div><div class=\"row\"><div ng-repeat=\"society in main.filteredSocietiesArray = (main.societies | societyFilter: main.selectedCountry | filter: main.textFilter)\"><div class=\"clearfix\" ng-if=\"$index % 2 == 0\"></div><div class=\"col-sm-12 col-md-6\"><div class=\"society-card\"><h4>{{society.name}}<br><span class=\"small\">{{society.countryName}}</span></h4><div class=\"row\" ng-show=\"society.website != \'\'\"><div class=\"col-sm-4\"><strong>Website:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.website}}\" target=\"_blank\">{{society.website}}</a></div></div><div class=\"row\" ng-show=\"society.email != \'\'\"><div class=\"col-sm-4\"><strong>Email:</strong></div><div class=\"col-sm-8\"><a href=\"mailto://{{society.email}}\" target=\"_blank\">{{society.email}}</a></div></div><div class=\"row\" ng-show=\"society.phone != \'\'\"><div class=\"col-sm-4\"><strong>Phone:</strong></div><div class=\"col-sm-8\">{{society.phone}}</div></div><div class=\"row\" ng-show=\"society.facebook != \'\'\"><div class=\"col-sm-4\"><strong>Facebook:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.facebook}}\" target=\"_blank\">{{society.facebook}}</a></div></div><div class=\"row\" ng-show=\"society.address1 != \'\' || society.address2 != \'\' || society.city != \'\' || society.stateprov != \'\' || society.postal != \'\'\"><div class=\"col-sm-4\"><strong>Address:</strong></div><div class=\"col-sm-8\"><span ng-show=\"society.address1 != \'\'\">{{society.address1}}<br><span ng-show=\"society.address2 != \'\'\">{{society.address2}}<br></span> <span ng-show=\"society.city != \'\'\">{{society.city}}</span>, <span ng-show=\"society.stateprov != \'\'\">{{society.stateprov}}</span> <span ng-show=\"society.postal != \'\'\">{{society.postal}}</span><span ng-show=\"society.city != \'\' && society.stateprov != \'\' && society.postal != \'\'\"><br></span> <span ng-show=\"society.countryName != \'\'\">{{society.countryName}}</span></span></div></div><hr ng-if=\"society.article1 != \'\' || society.article2 != \'\' || society.article3 != \'\' || society.article4 != \'\' || society.article5 != \'\' || society.article6 != \'\'\"><div class=\"row\" ng-show=\"society.article1 != \'\'\"><div class=\"col-sm-4\"><strong>Article:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.article1}}\" target=\"_blank\">{{society.article1title}}</a></div></div><div class=\"row\" ng-show=\"society.article2 != \'\'\"><div class=\"col-sm-4\"><strong>Article:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.article2}}\" target=\"_blank\">{{society.article2title}}</a></div></div><div class=\"row\" ng-show=\"society.article3 != \'\'\"><div class=\"col-sm-4\"><strong>Article:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.article3}}\" target=\"_blank\">{{society.article3title}}</a></div></div><div class=\"row\" ng-show=\"society.article4 != \'\'\"><div class=\"col-sm-4\"><strong>Article:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.article4}}\" target=\"_blank\">{{society.article4title}}</a></div></div><div class=\"row\" ng-show=\"society.article5 != \'\'\"><div class=\"col-sm-4\"><strong>Article:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.article5}}\" target=\"_blank\">{{society.article5title}}</a></div></div><div class=\"row\" ng-show=\"society.article6 != \'\'\"><div class=\"col-sm-4\"><strong>Article:</strong></div><div class=\"col-sm-8\"><a href=\"{{society.article6}}\" target=\"_blank\">{{society.article6title}}</a></div></div></div><br></div></div></div></div><hr><div class=\"row\"><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div><div class=\"col-sm-12 col-md-8\"><p>If you have any questions or need help finding a particular video, DVD, tract, book or any other Christian resource in any language of the world, please contact <a href=\"mailto:brianformissions@gmail.com\" target=\"_blank\">brianformissions@gmail.com</a></p></div><div class=\"col-sm-2 visible-lg visible-md\">&nbsp;</div></div></div>");}]);